// @flow
import { handleResponseOld, makeGet } from './helpers';

type FetchCatalogsTodayCountApiParams = {
    deployment: string,
};

export const fetchCatalogsTodayCountApi = ({ deployment }: FetchCatalogsTodayCountApiParams) => {
    return new Promise<any>((resolve, reject) => {
        const request = makeGet({ deployment, path: '<ITEM-API>spa/small/catalogtodaycount' });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
};

type FetchResultsApiParams = {
    deployment: string,
    queryParams: any,
};

export const fetchResultsApi = ({ deployment, queryParams }: FetchResultsApiParams) => {
    return new Promise<any>((resolve, reject) => {
        const request = makeGet({
            apiPath: 'auctioncalendar',
            deployment,
            path: '<SEARCH-API>',
            queryParams,
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
};
